import { Config, httpPost } from "../../services/api";

export const sdkApplePaySession = async ({
  validationUrl,
  secret,
  parentOrigin,
  methodId,
  merchantIdentifier,
}: {
  secret: string | null;
  methodId: string | null;
  merchantIdentifier: string | null;
  validationUrl: string;
  parentOrigin: string;
}) => {
  return httpPost(
    `${import.meta.env.VITE_API_BASE}/api/${
      Config.apiVersion
    }/providers/applepay/session/`,
    {
      ...(secret && { secret }),
      ...(methodId && { method_id: methodId }),
      ...(merchantIdentifier && { merchant_identifier: merchantIdentifier }),
      validation_url: validationUrl,
      parent_origin: parentOrigin,
    },
    true
  );
};
